import { render, staticRenderFns } from "./SystemSettingCreate.vue?vue&type=template&id=1ecd04e1"
import script from "./SystemSettingCreate.vue?vue&type=script&lang=js"
export * from "./SystemSettingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports